import { PlantImages } from "../types";

export const images: PlantImages = {
  200: {
    gardenImages: [
      {
        image: "/IMG_1549.jpg",
      },
    ],
    googleImages: [
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/A1%2Bi%2BlusPTL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/Verbena-bonariensis-Finesse-Primed-Seeds/dp/B07JVQJ6LN",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/08/pl2000010879.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/verbena-bonariensis/classid.2000010879/",
      },
      {
        image:
          "http://cdn.shopify.com/s/files/1/1537/5553/products/03702_grande.jpg?v=1486443130",
        imageLink:
          "https://www.harrisseeds.com/products/03702-verbena-bonariensis-finesse",
      },
      {
        image:
          "https://lathamsnursery.com/wp-content/uploads/2016/08/Photo-May-17-11-47-27-AM-e1526658604870.jpg",
        imageLink:
          "https://lathamsnursery.com/product/verbena-brazilian-vervain-1g-verbena-bonariensis/",
      },
    ],
  },
  201: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/l/a/lavender-munstead3.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/lavendula-angustifolia-munstead-blue-english-lavender-dwarf-compact-blue",
      },
      {
        image:
          "http://www.perennials.com/watermark.php?path=perennials/1-315-100.jpg&watermark=images/watermark_heritage.png&xpos=.88&ypos=.95",
        imageLink:
          "http://www.perennials.com/plants/lavandula-angustifolia-munstead.html",
      },
      {
        image:
          "https://www.cowellsgc.co.uk/files/images/webshop/lavandula-angustifolia-munstead-1555432640_l.jpg",
        imageLink:
          "https://www.cowellsgc.co.uk/lavandula-angustifolia-munstead-3l",
      },
      {
        image:
          "http://kalliergeia.com/wp-content/uploads/2018/03/3.-Lavandula-angustifolia-Munstead-1.jpg",
        imageLink:
          "https://www.kalliergeia.com/en/lavandula-angustifolia-munstead/",
      },
    ],
  },
  202: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/18/pl0000001835.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/polypodium-vulgare/classid.1835/",
      },
      {
        image:
          "https://www.penlanperennials.co.uk/wp-content/uploads/2015/10/Polypodium-vulgare-e1447409740720.jpg",
        imageLink:
          "https://www.penlanperennials.co.uk/plant/hardy-ferns/polypodium-vulgare-2/",
      },
      {
        image:
          "https://www.botanicaplantnursery.co.uk/user/products/large/Polypodium%20vulgare.JPG",
        imageLink:
          "https://www.botanicaplantnursery.co.uk/polypodium-vulgare-7353-p.html",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/0/0/00D9F0715582C838706DA5A094DE6BC2.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/e15187-polypodium-vulgare-common-polypody-fern",
      },
    ],
  },
  204: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Alchemilla_mollis_2_1024x1024.JPG?v=1509354119",
        imageLink:
          "https://www.ballyrobertgardens.com/products/alchemilla-mollis",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/02/59/pl2000025906.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/alchemilla-mollis/classid.2000025906/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1537/5553/products/61396_1024x1024.jpg?v=1518033627",
        imageLink:
          "https://www.harrisseeds.com/products/61396-alchemilla-mollis",
      },
      {
        image:
          "https://www.thompson-morgan.com/product_images/100/zoom/z-ALCH-T63828-A_h.jpg",
        imageLink:
          "https://www.thompson-morgan.com/p/alchemilla-mollis-thriller/t63828TM",
      },
      {
        image:
          "https://apps.rhs.org.uk/plantselectorimages/detail/RHS_WSYD0005811_89.JPG",
        imageLink:
          "https://www.rhs.org.uk/plants/774/Alchemilla-mollis/Details",
      },
      {
        image: "https://www.greatgardenplants.com/images/popup/ALCMO1Q-1.jpg",
        imageLink:
          "https://www.greatgardenplants.com/product/perennial-ground-cover-alchemilla-mollis/a-z-shade-perennials",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/02/pl0000000233.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/alchemilla-mollis/classid.233/",
      },
    ],
  },
  205: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.haagplanten.net/media/catalog/category/Crataegus_monogyna_-_2.JPG",
        imageLink:
          "https://www.haagplanten.net/bladverliezende-haagplanten/meidoornhaag.html",
      },
      {
        image:
          "https://www.tuinplant.nl/media/magpleasure/mpblog/post_thumbnail_file/d/4/cache/1/ece9a24a761836a70934a998c163f8c8/d4774e3053b575334d0104635385067c.jpg",
        imageLink: "https://www.tuinplant.nl/blog/meidoornhaag",
      },
      {
        image:
          "https://www.haagplanten.nl/media/catalog/product/cache/1/image/760x760/0dc2d03fe217f8c83829496872af24a0/c/r/crataegus-monogyna.jpg",
        imageLink: "https://www.haagplanten.nl/meidoornhaag.html",
      },
      {
        image:
          "https://www.garmundo.nl/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/c/r/crataegus_monogyna_hecke.jpg",
        imageLink: "https://www.garmundo.nl/meidoornhaag.html",
      },
    ],
  },
  206: {
    gardenImages: [{ image: "/IMG_1582.jpg" }],
    googleImages: [
      {
        image: "https://plants.connon.ca/Content/Images/Photos/F584-15.jpg",
        imageLink:
          "https://plants.connon.ca/11100004/Plant/1642/Globe_Norway_Maple",
      },
      {
        image:
          "https://previews.123rf.com/images/kornyeyeva/kornyeyeva1604/kornyeyeva160400128/57449467-acer-platanoides-globosum-.jpg",
        imageLink:
          "https://www.123rf.com/photo_57449467_acer-platanoides-globosum-.html",
      },
      {
        image:
          "http://architecturalplants.com/media/product/small/265636813.jpg",
        imageLink:
          "http://architecturalplants.com/plants/id/acer-platanoides-globosum",
      },
      {
        image:
          "https://www.paramountplants.co.uk/images/shop/main/acer-platanoides-globosum.jpg",
        imageLink:
          "https://www.paramountplants.co.uk/plant/apg/acer-platanoides-globosum.html",
      },
    ],
  },
  207: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.almanac.com/sites/default/files/styles/primary_image_in_article/public/image_nodes/rhododendron-pink-bush-edit.jpg?itok=ayZC3YZX",
        imageLink: "https://www.almanac.com/plant/rhododendrons",
      },

      {
        image:
          "https://www.gardeningknowhow.com/wp-content/uploads/2011/03/Rhododendron.jpg",
        imageLink:
          "https://www.gardeningknowhow.com/ornamental/shrubs/rhododendron/rhododendron-care.htm",
      },
      {
        image:
          "https://www.almanac.com/sites/default/files/users/The%20Editors/rhododendron-pink-side-crop_full_width.jpg",
        imageLink: "https://www.almanac.com/plant/rhododendrons",
      },
      {
        image:
          "https://www.whiteflowerfarm.com/mas_assets/cache/image/5/5/c/a/21962.Jpg",
        imageLink: "https://www.whiteflowerfarm.com/66596-product.html",
      },
    ],
  },
  208: {
    gardenImages: [
      {
        image: "/IMG_1532.jpg",
      },
    ],
    googleImages: [
      {
        image:
          "https://www.classicroses.co.uk/media/catalog/product/cache/1/image/443x443/9df78eab33525d08d6e5fb8d27136e95/R/o/Rosa_Gallica_Officinalis_BM_2015_4_300px_34.jpg",
        imageLink:
          "https://www.classicroses.co.uk/rosa-gallica-officinalis-shrub-rose.html",
      },
      {
        image: "https://pfaf.org/Admin/PlantImages/RosaGallica2.jpg",
        imageLink: "https://pfaf.org/user/Plant.aspx?LatinName=Rosa+gallica",
      },
      {
        image:
          "https://www.monaconatureencyclopedia.com/wp-content/uploads/2008/08/r-137-3_rosa_gallica_officinalis.jpg",
        imageLink:
          "https://www.monaconatureencyclopedia.com/rosa-gallica-officinalis/?lang=en",
      },
      {
        image: "http://oldroses.nl/wp-content/uploads/2013/03/059.jpg",
        imageLink:
          "http://oldroses.nl/my-roses/gallicas/rosa-gallica-officinalis/",
      },
    ],
  },
  209: {
    gardenImages: [
      {
        image: "/IMG_1280.jpg",
      },
      { image: "/OTD_Jubileum_2019_69.jpg" },
    ],
    googleImages: [
      {
        image:
          "https://get.pxhere.com/photo/nature-plant-flower-petal-bouquet-rose-red-garden-red-rose-flowers-roses-petals-shrub-beauty-floribunda-flowering-plant-garden-roses-rose-family-annual-plant-land-plant-rosa-centifolia-rose-order-rosa-gallica-rosa-wichuraiana-613022.jpg",
        imageLink: "https://pxhere.com/nl/photo/613022",
      },
      {
        image: "http://www.fotoplatforma.pl/foto_galeria/3086__DSCN0510.jpg",
        imageLink: "http://www.fotoplatforma.pl/nl/bigimages/3086/",
      },
      {
        image:
          "https://cdn.pixabay.com/photo/2018/08/09/11/45/red-roses-3594336_960_720.jpg",
        imageLink:
          "https://pixabay.com/nl/rode-rozen-zomer-tuin-de-natuur-3594336/",
      },
    ],
  },
  260: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://plantsrescue.com/wp-content/uploads/2013/08/Athyrium-niponicum-Pictum.jpg",
        imageLink:
          "https://www.plantsrescue.com/tag/athyrium-niponicum-metallicum/",
      },
      {
        image:
          "https://www.turn-it-tropical.co.uk/wp-content/uploads/2016/10/athyrium-nipponicum_metallicum.jpg",
        imageLink:
          "https://www.turn-it-tropical.co.uk/product/athyrium-nipponicum-metallicum-3l/",
      },
      {
        image: "http://plants.connon.ca/Content/Images/Photos/F232-04.jpg",
        imageLink:
          "http://plants.connon.ca/11100004/Plant/3343/Japanese_Painted_Fern",
      },
      {
        image:
          "https://www.coblands.co.uk/userfiles/product_image/5aeae2fc8927b-athyrium-nipponicum-metallicum.jpg",
        imageLink:
          "https://www.coblands.co.uk/products/1372-athyrium-nipponicum-metallicum-2l",
      },
    ],
  },
  300: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/v/i/vinca-atropurpurea1.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/vinca-minor-atropurpurea-purple-evergreen-periwinkle",
      },
      {
        image:
          "http://www.pcgroundcovers.com/images/products/preview/vinminatrbrw.jpg",
        imageLink:
          "http://www.pcgroundcovers.com/Vinca-Periwinkle-Myrtle/Purple-Flowered-Vinca-Vinca-minor-atropurpurea-Bare-Root-100-for-48.00/",
      },
      {
        image:
          "https://www.midwestgroundcovers.com/_ccLib/image/plants/DETA2-230.jpg",
        imageLink:
          "https://www.midwestgroundcovers.com/plant/Vinca-minor-Atropurpurea",
      },
      {
        image:
          "http://www.flowermedia.com/static2/preview2/stock-photo-vinca-minor-atropurpurea--purpleflowered-periwinkle-102052-10739.jpg",
        imageLink:
          "https://www.flowermedia.com/stock-photo/vinca-minor-atropurpurea-purpleflowered-periwinkle-102052-10739.html",
      },
      {
        image:
          "https://www.gardens4you.ie/media/catalog/product/cache/9/image/500x/9df78eab33525d08d6e5fb8d27136e95/F/D/FD16460WH_3.jpg",
        imageLink:
          "https://www.gardens4you.ie/vinca-minor-atropurpurea-ie-en.html",
      },
      {
        image:
          "http://www.vanberkumnursery.com/wp-content/uploads/2016/01/Vinca-minor-Lattanzio-Landscapes.jpg",
        imageLink:
          "http://www.vanberkumnursery.com/plant/vinca-minor-atropurpurea/",
      },
      {
        image:
          "https://plants.oaklandnursery.com/Content/Images/Photos/F294-05.jpg",
        imageLink:
          "https://plants.oaklandnursery.com/12130001/Plant/4213/Burgundy_Periwinkle",
      },
      {
        image:
          "https://www.florablom.com/media/catalog/product/cache/4/image/9df78eab33525d08d6e5fb8d27136e95/1/4/1432204047vinca_minor___atropurpurea___1/purple-periwinkle-atropurpurea-(vinca-minor).jpg",
        imageLink:
          "https://www.florablom.com/en/purple-periwinkle-atropurpurea-vinca-minor/",
      },
      {
        image:
          "https://www.midwestgroundcovers.com/_ccLib/image/plants/DETA-230.jpg",
        imageLink:
          "https://www.midwestgroundcovers.com/plant/Vinca-minor-Atropurpurea",
      },
    ],
  },
  400: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/33/pl2000013309.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/delphinium-galahad-pacific-hybrids-series/classid.2000013309/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Delphinium_Galahad_Pacific_Hybrid_Series_1_nbrcg_1024x1024.jpg?v=1453905182",
        imageLink:
          "https://www.ballyrobertgardens.com/products/delphinium-galahad-pacific-hybrid-series",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Delphinium_Galahad_Pacific_Hybrid_Series_2_nbrcg_1024x1024.jpg?v=1453905182",
        imageLink:
          "https://www.ballyrobertgardens.com/products/delphinium-galahad-pacific-hybrid-series",
      },
      {
        image:
          "https://cdn.mr-fothergills.co.uk/product-images/op/z/DEL-039z.jpg",
        imageLink:
          "http://www.mr-fothergills.co.uk/Flower-Plants/Delphinium-Plants/Delphinium-Galahad-Plants.html",
      },
    ],
  },
  401: {
    gardenImages: [{ image: "/IMG_1521.jpg" }],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/12/pl0000001281.jpg?width=940&height=940",
        imageLink:
          "https://www.rhsplants.co.uk/plants/_/rosa-pauls-scarlet-climber/classid.1281/",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/31/Feldkirchen_Amthofgasse_Kletterrose_%27Paul%27s_Scarlet_Climber%27_04062018_3555.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Feldkirchen_Amthofgasse_Kletterrose_%27Paul%27s_Scarlet_Climber%27_04062018_3555.jpg",
      },
      {
        image:
          "https://www.thompson-morgan.com/product_images/100/optimised/ROSE-T11939P-A.jpg",
        imageLink:
          "https://www.thompson-morgan.com/p/rose-pauls-scarlet-climbing/t11939pTM",
      },
    ],
  },
  402: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://dkpo4ygqb6rh6.cloudfront.net/APPELTERN_NL/imageresized/139578/5f3c2fabf4d38a0bcc7dcfaf07349af6/564_751_80_normaljpg/rosa_constance_spry_geurende_roze_klimroos.jpg",
        imageLink:
          "https://appeltern.nl/nl/shop/groen/tuinplanten/rozen/klimrozen_leirozen/rosa_constance_spry_geurende_roze_klimroos",
      },
      {
        image:
          "https://static.mijnwebwinkel.nl/winkel/botanici-shop/image/cache/full/678f456b8171f6f1d947000d8e9d43a3f8cf3fb5.jpg",
        imageLink:
          "https://www.botanici-shop.nl/a-42060046/rozen/roze-klimroos/",
      },
      {
        image:
          "https://dkpo4ygqb6rh6.cloudfront.net/APPELTERN_NL/imageresized/139584/7c4fbade255fa1bf6c9ad6568ec1b750/564_846_80_normaljpg/rosa_giardina_kw_geurende_roze_klimroos.jpg",
        imageLink:
          "https://appeltern.nl/nl/shop/groen/tuinplanten/rozen/rozen_kale_wortel/rosa_giardina_kw_geurende_roze_klimroos",
      },
      {
        image:
          "https://plantnewday.nl/media/catalog/product/R/o/Rosa__Coral_Dawn_4be2ac1447421.jpg",
        imageLink:
          "https://plantnewday.nl/tuinplanten/klimplanten/alle-klimplanten/klimroos-roze",
      },
    ],
  },
  403: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://rosariumlottum.com/wp-content/uploads/2014/12/mme_-alfred-carriere_-klimroos_199_2.jpg",
        imageLink:
          "https://rosariumlottum.com/product/klimrozen/mme-alfred-carriere-klimroos/",
      },
      {
        image:
          "https://dkpo4ygqb6rh6.cloudfront.net/APPELTERN_NL/imageresized/97920/e112634d448f42026862fb930be33a1d/480_720_80_normaljpg/rosa_guirlande_damour_kw_wit_bloeiende_rambler_klimroos.jpg",
        imageLink:
          "https://appeltern.nl/nl/shop/groen/tuinplanten/rozen/rozen_kale_wortel/rosa_guirlande_damour_kw_wit_bloeiende_rambler_klimroos",
      },
      {
        image:
          "https://dkpo4ygqb6rh6.cloudfront.net/APPELTERN_NL/imageresized/97933/bfed24524a83081843b670020c67a45c/1320_880_80_normaljpg/rosa_helena_renaissance_kw_wit_met_roze_klimroos.jpg",
        imageLink:
          "https://appeltern.nl/nl/shop/groen/tuinplanten/rozen/rozen_kale_wortel/rosa_helena_renaissance_kw_wit_met_roze_klimroos",
      },
    ],
  },
};
